module.exports = ".morningstar-rating .star {\n  margin-right: 5px;\n}"